//for authentication process see the $auth directive
//https://github.com/sahat/satellizer
(function() {
    'use strict';
    var constant = {
        LOGIN_SUCCESS: 'auth_success',
        LOGOUT: 'auth_logout',
        LOGIN_FAILURE: 'auth_failure',
        USER_CHANGE: 'auth_user_change',
        TOKEN_REFRESH: 'auth_token_refresh'
    };
    var setUser = function(user) {
        var usr = {};
        Object.keys(user).forEach(function(key) {
            //remove all angular key from object, thas mean all the
            //key start with $
            if (!/^\$/.test(key)) {
                usr[key] = user[key];
            }
        });
        //TODO, emit user that change
        localStorage.setItem('user', angular.toJson(usr));
    };
    angular
        .module('emarket.auth')
        .factory('Auth', ['$rootScope', '$http', '$log', '$q', '$state', '$auth', '$mdToast', 'restmod', 'ErrorHandler', 'Announcer', 'PATH', function($rootScope,
            $http,
            $log,
            $q,
            $state,
            $auth,
            $mdToast,
            restmod,
            ErrorHandler,
            Announcer,
            PATH) {
            var announcer = Announcer.createEmitter();
            var auth = {
                login: function(user) {
                    var promise = $auth
                        .login(user)
                        .then(function(response) {
                            setUser(response.data.user, true);
                            announcer.emit(constant.LOGIN_SUCCESS);
                            return response.data;
                        })
                        .catch(function(err) {
                            announcer.emit(constant.LOGIN_FAILURE);
                            throw err;
                        });
                    return promise;
                },
                logout: function() {
                    var user = auth.getUser();
                    var fullName = '';
                    if (user) {
                        fullName = auth.getUser().displayName;
                    }
                    var toast = $mdToast
                        .simple()
                        .textContent('Vuelve pronto ' + fullName)
                        .hideDelay(3000);
                    $mdToast.show(toast);
                    $auth.logout();
                    localStorage.clear();
                    $rootScope.$emit(constant.LOGOUT);
                    $state.go('main.home');
                },
                setUser: function(user, ignoreEvent) {
                    setUser(user);
                    if (!ignoreEvent) {
                        $rootScope.$emit(constant.USER_CHANGE);
                    }
                },
                getUser: function() {
                    var user = localStorage.getItem('user');
                    if ($auth.isAuthenticated() && user) {
                        return angular.fromJson(user);
                    }
                },
                validateToken: function(token, type, extraData) {
                    var url = '/auth/email/validate';
                    var query = {
                        token: token
                    };
                    if (type === 'forgot') {
                        url = '/auth/forgot/validate';
                    }
                    if (extraData) {
                        Object.keys(extraData).forEach(function(key) {
                            query[key] = extraData[key];
                        });
                    }
                    return restmod
                        .model(url)
                        .$create(query)
                        .$asPromise();
                },
                validateField: function(field, value) {
                    var url = PATH.api + '/auth/validate/' + field + '?value=' + value;
                    return $http.get(url).then(function(response) {
                        if (response.data.exist === true) {
                            return $q.reject();
                        }
                    });
                },
                refreshToken: function() {
                    var url = PATH.api + '/auth/refresh';
                    return $http.post(url).then(function(response) {
                        if (response.data.token) {
                            $auth.setToken(response.data.token);
                            announcer.emit(constant.TOKEN_REFRESH);
                        }
                    });
                },
                sendForgotPassword: function(userOrEmail) {
                    var url = PATH.api + '/auth/forgot/';
                    return $http.post(url, {
                        email: userOrEmail
                    });
                },
                requiredAuthentication: function() {
                    return $q(function(resolve, reject) {
                        if ($auth.isAuthenticated()) {
                            resolve(true);
                        } else {
                            var error = ErrorHandler.create('UNAUTHORIZED');
                            reject(error);
                        }
                    });
                },
                events: constant
            };
            return auth;
        }]);
}());
